import "./App.css";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import SignIn from "./projects/shared/signIn";
import SignInLeadgen from "./projects/ESID-25-013/pages/signIn";

import { SignUp } from "./projects/shared/signUp";
import { ProjectProvider } from "./context/ProjectContext";
import { AuthProvider } from "./context/AuthContext";
import GrootbijgaardenDashboard from "./projects/ESID-24-031/pages/dashboard";
import { NotAuthorized } from "./projects/shared/notAuthorized";
import { NotFound } from "./projects/shared/notFound";
import ProjectSelection from "./projects/shared/pages/projectSelection";
import DailyPlannerModalGrootbijgaarden from "./projects/ESID-24-031/components/dailyplanner/DailyPlannerModal";

import DailyPlannerModal from "./projects/ESID-24-003/components/dailyplanner/DailyPlannerModal";

import { SettingsProvider } from "./projects/ESID-24-003/context/SettingsContext";
import { SimulationProvider } from "./projects/ESID-25-006/context/SimulationContext";
import { SettingsProvider as WDPSettingsProvider } from "./projects/ESID-25-006/context/SettingsContext";
import ProtectedLayout from "./layouts/ProtectedLayout";  // You'll need to create this
import LoadingScreen from "./projects/shared/components/LoadingScreen/LoadingScreen";
import { useAlert } from "./projects/shared/hooks/useAlert";
import BelcoladeRoutes from "./routes/BelcoladeRoutes";
import GrootbijgaardenRoutes from "./routes/GrootBijgaardennRoutes";
import LeadgenRoutes from "./routes/LeadgenRoutes";
import LummenRoutes from "./routes/LummenRoutes";
import NoPage from "./projects/ESID-25-013/pages/nopage";
import WDPRoutes from "./routes/WDPRoutes";

function App({ gitRevision, stage }) {
  const [theme, colorMode] = useMode();
  const [loading, setLoading] = useState(false);
  const { alert, triggerAlert } = useAlert();
  const [settings, setSettings] = useState(null);


  const settingsTrigger = (settings) => {
    setSettings(settings);
  };

  useEffect(() => {
    document.title = 'Endustries';
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={`app ${stage} ${gitRevision}`}>
          {loading && <LoadingScreen loading={loading} />}

          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Navigate to="/signin" />} />
            <Route path="/signin" element={<SignIn setLoading={setLoading} />} />
            <Route path="/signup" element={<SignUp triggerAlert={triggerAlert} />} />
            <Route path="/signin-leadgen" element={<SignInLeadgen setLoading={setLoading} />} />
            <Route path="/nopage" element={<NoPage />} />
            {/* Protected routes wrapped in providers */}
            <Route element={
              <AuthProvider>
                <ProjectProvider>
                  <SettingsProvider>
                    <ProtectedLayout 
                      alert={alert}
                      setLoading={setLoading}
                      triggerAlert={triggerAlert}
                      settingsTrigger={settingsTrigger}
                    />
                  </SettingsProvider>
                </ProjectProvider>
              </AuthProvider>
            }>
              <Route path="/project-selection" element={<ProjectSelection />} />
              <Route path="/esid-24-003/*" element={<BelcoladeRoutes triggerAlert={triggerAlert} setLoading={setLoading} />} />
              <Route path="/esid-24-031/*" element={<GrootbijgaardenRoutes triggerAlert={triggerAlert} setLoading={setLoading} />} />
              <Route path="/esid-25-011/*" element={<LummenRoutes triggerAlert={triggerAlert} setLoading={setLoading} />} />
              <Route path="/esid-25-006/*" element={
                <SimulationProvider>
                  <WDPSettingsProvider>
                    <WDPRoutes triggerAlert={triggerAlert} setLoading={setLoading} />
                  </WDPSettingsProvider>
                </SimulationProvider>} />
              <Route path="/esid-25-013/*" element={<LeadgenRoutes triggerAlert={triggerAlert} setLoading={setLoading} settings={settings} />} />
              <Route path="/not-authorized" element={<NotAuthorized />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;